import React, {Component} from 'react';

class CustomTableNotice extends Component {

	render() {
		return (
			<div className="notice notice-warning inline" style={{display: 'block'}}><p>Please choose a table first!</p></div>
		)
	}
}

export default CustomTableNotice;
